export default "__VITE_ASSET__DmmjKA2H__"